// One source of truth for trust-registry colors, shared by the Trust Graph
// loader and the Members roster so associations read consistently everywhere.
export const REGISTRY_COLORS = {
  AAM: '#76B900',          // Alliance for Audited Media (brand green)
  JTI: '#2196F3',          // Journalism Trust Initiative (blue)
  Journallist: '#9C27B0',  // Journallist (purple)
  IPTC: '#FF9800',         // IPTC (orange)
  DCN: '#00BCD4',          // Digital Content Next (teal)
};

export const colorForRegistry = (short) => REGISTRY_COLORS[short] || '#78909C';
